import { vfmPlugin } from 'vue-final-modal';
import DialogBase from '@/components/dialogs/Dialog.vue';

export function setupVueFinalModal(app) {
    app.use(vfmPlugin({
        key: '$vfm',
        componentName: 'VueFinalModal',
        dynamicContainerName: 'ModalsContainer'
    }));
    app.component('DialogBase', DialogBase);
}
